import type { AnchorHTMLAttributes, MouseEvent } from "react";
import { navigate } from "../lib/router";

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  to: string;
  replace?: boolean;
};

/**
 * Ссылка внутри сайта. Настоящий <a href>: открыть в новой вкладке, скопировать адрес,
 * долгое нажатие на телефоне — всё работает. Обычный клик перехватывается роутером.
 */
export function Link({ to, replace = false, onClick, target, ...rest }: Props) {
  function handleClick(event: MouseEvent<HTMLAnchorElement>) {
    onClick?.(event);
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (target && target !== "_self") return;
    event.preventDefault();
    navigate(to, { replace });
  }
  return <a href={to} onClick={handleClick} {...(target ? { target } : {})} {...rest} />;
}
